<template>
  <div class="goods-manage-box" v-loading="loading > 0">
    <Header :title="title"></Header>
    <div class="container">
      <div class="content">
        <!-- 表格 -->
        <div class="filter-box">
          <div class="btn-box">
            <div class="label">状态：</div>
            <el-select
              v-model="filter.status"
              size="small"
              class="select"
              style="width: 153px"
              placeholder="请选择"
            >
              <el-option :value="null" label="全部"> </el-option>
              <el-option :value="3" label="上架中"> </el-option>
              <el-option :value="1" label="隐藏"> </el-option>
            </el-select>
            <el-input
              class="input"
              v-model="filter.name"
              style="width: 188px; margin-left: 40px"
              placeholder="输入样品名称"
              size="small"
            ></el-input>
            <button class="search" @click="search">搜索</button>
            <button class="reset" @click="reset">重置</button>
          </div>
          <div class="btn" @click="toGood('add')">+ 添加样品</div>
        </div>
        <el-table
          :data="goodsList"
          class="table table no-border-table"
          ref="orderTable"
          :header-cell-style="{
            border: 'none',
            color: '#333',
            background: '#f6f6f6',
            borderBottom: '1px solid #E8E8E8',
            height: '54px',
          }"
          :row-style="{
            height: '54px',
          }"
        >
          <el-table-column prop="master_pic" align="center" label="样品主图">
            <div slot-scope="scope">
              <el-image
                class="master-pic"
                :src="scope.row.masterPic"
                :preview-src-list="[scope.row.masterPic]"
              >
              </el-image>
            </div>
          </el-table-column>
          <el-table-column
            prop="name"
            align="center"
            label="样品名称"
          ></el-table-column>
          <el-table-column 
            prop="price" 
            align="center" 
            label="宝宝币数量/个">
          </el-table-column>
          <el-table-column prop="status" align="center" label="状态">
            <div slot-scope="scope">
              {{ scope.row.status === 3 ? "上架中" : "隐藏" }}
            </div>
          </el-table-column>
          <el-table-column prop="twig" align="center" label="排序">
            <!-- <template slot-scope="scope">
              <u class="blue" @click="editSort(scope.row)">{{
                scope.row.twig
              }}</u>
            </template> -->
          </el-table-column>
          <el-table-column label="操作" align="center" width="260">
            <div slot-scope="scope">
              <div class="table-btn-box">
                <button
                  size="mini"
                  class="table-btn"
                  style="width: 85px;min-width: 85px;"
                  @click="toGood('edit', scope.row.id)"
                >
                  编辑信息
                </button>
                <button
                  size="mini"
                  class="table-btn"
                  v-if="scope.row.status === 3"
                  @click="updateStatus(1, scope.row.id)"
                >
                  下架
                </button>
                <button
                  size="mini"
                  class="table-btn"
                  v-else
                  @click="updateStatus(3, scope.row.id)"
                >
                  上架
                </button>
                <button
                  size="mini"
                  class="table-btn"
                  @click="deleteGood(scope.row.id)"
                >
                  删除
                </button>
              </div>
            </div>
          </el-table-column>
        </el-table>
      </div>
      <!-- 分页按钮 -->
      <div class="footer" :key="paginationKey">
        <el-pagination
          @current-change="handleCurrentChange"
          :current-page.sync="currentPage"
          background
          layout="total, prev, pager, next, jumper"
          :page-size="size"
          :total="total"
        ></el-pagination>
      </div>
    </div>
    <!-- 修改排序弹窗 -->
    <el-dialog title="更改排序" width="400px" :visible.sync="sortShow">
      <el-form label-width="60px" size="mini" ref="editSort" inline-message>
        <el-form-item label="排序：" prop="tableData" style="margin-top: 15px">
          <el-input v-model="currentSort" type="number" />
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button class="btn cancel-btn" @click="sortShow = false"
          >取 消</el-button
        >
        <el-button class="btn confirm-btn" @click="saveSort">确 定</el-button>
      </div>
    </el-dialog>
    <el-dialog
      :show-close="false"
      :close-on-click-modal="false"
      title="生成中..."
      :visible.sync="showProgressDialog"
      width="30%"
      center
    >
      <el-progress
        :percentage="progress"
        :text-inside="true"
        :stroke-width="18"
      ></el-progress>
    </el-dialog>
  </div>
</template>

<script type="text/ecmascript-6">
import dayjs from 'dayjs';
import Header from '../../components/common/header';
import myUtils from '../../components/common/whatever2excel';
export default {
  components: {
    Header
  },
  name: 'goods-manage',
  data() {
    return {
      currentPage: 1, // 当前页码
      size: 20, // 每页条数
      total: 0, // 总页数
      loading: 0, // 加载中
      title: {
        // 页面标题
        firstTitile: '样品管理',
        secondTitle: '样品管理'
      },
      filter: {
        status: null,
        name: '',
      },
      goodsList: [], // 列表
      currentId: null,
      currentSort: null,
      sortShow: false,
      paginationKey: +new Date(),
      showProgressDialog: false,
      progress: 0,
      // brandList: [],
    };
  },
  beforeRouteEnter(to, from, next) {
    if (from.name !== 'sample') {
      sessionStorage.setItem('sampleManage', '');
    }
    next();
  },
  mounted() {
    let data = sessionStorage.getItem('sampleManage')
      ? JSON.parse(sessionStorage.getItem('sampleManage'))
      : '';
      console.log(data);
    if (data) {
      this.filter = {
        ...this.filter,
        ...data.filter
      };
      this.currentPage = data.currentPage;
      // this.category = data.category || []
      this.paginationKey = +new Date();
      this.setSearchData();
    }
    // 获取列表
    // this.getBrandList();
    this.getSampleList();
  },
  filters: {
    // 时间格式化
    dateFormat(date) {
      if (!date) return '请选择时间';
      let day = dayjs(date);
      return day.format('YYYY-MM-DD HH:mm:ss');
    }
  },
  computed: {},
  methods: {
    setSearchData() {
      let sampleManage = {
        currentPage: this.currentPage,
        filter: this.filter,
        // category: this.category || []
      };
      sessionStorage.setItem('sampleManage', JSON.stringify(sampleManage));
    },
    // 切换页码
    handleCurrentChange(page) {
      this.currentPage = page;
      this.getSampleList();
    },
    // 获取产品列表
    getSampleList() {
      this.setSearchData();
      this.loading++;
      this.httpGet(this.$root.getSampleList, {
        page: this.currentPage,
        size: this.size,
        ...this.filter,
      }).then(
        (res) => {
          this.loading--;
          this.goodsList = res.list;
          this.total = res.total;
        },
        (res) => {
          this.loading--;
          this.$message.error(res);
        }
      );
    },
    // 过滤
    search() {
      console.log(this.filter);
      this.currentPage = 1;
      this.getSampleList();
    },
    reset(){
      this.filter = {
        status: null,
        name: '',
      };
      this.currentPage = 1;
      this.getSampleList();
    },
    editSort(rowData) {
      // 更改排序
      this.currentId = rowData.id;
      this.sortShow = true;
      this.currentSort = rowData.twig;
    },
    saveSort() {
      // 保存排序
      this.loading++;
      this.httpPut(this.$root.updateGoodTwig, {
        id: +this.currentId,
        twig: +this.currentSort
      }).then(
        (res) => {
          this.$message({
            message: '修改成功！',
            type: 'success'
          });
          this.getSampleList();
          this.loading--;
          this.sortShow = false;
        },
        (err) => {
          this.loading--;
          this.$message.error(err);
        }
      );
    },
    updateStatus(status, id) {
      this.$confirm(
        `<p class='title'><i class='icon el-icon-question'></i>提醒</p><p class='text'>确定要将产品${
          status === 1 ? '放入仓库' : '上架'
        }吗</p>`,
        {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          cancelButtonClass: 'cancel-btn',
          confirmButtonClass: 'confirm-btn',
          customClass: 'confirm-box',
          dangerouslyUseHTMLString: true,
          showClose: false,
          type: 'none'
        }
      ).then(() => {
        this.loading++;
        this.httpPut(this.$root.updateGoodStatus, {
          id,
          status
        }).then(
          (res) => {
            this.loading--;
            this.$message({
              message: '操作成功',
              type: 'success'
            });
            this.getSampleList();
          },
          (res) => {
            this.loading--;
            this.$message.error(res);
          }
        );
      });
    },
    // 删除产品
    deleteGood(id) {
      this.$confirm(
        `<p class='title'><i class='icon el-icon-question'></i>提醒</p><p class='text'>确定要删除样品吗</p>`,
        {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          cancelButtonClass: 'cancel-btn',
          confirmButtonClass: 'confirm-btn',
          customClass: 'confirm-box',
          dangerouslyUseHTMLString: true,
          showClose: false,
          type: 'none'
        }
      ).then(() => {
        this.loading++;
        this.httpDelete(this.$root.deleteGood, {
          id
        }).then(
          (res) => {
            this.loading--;
            this.$message({
              message: '操作成功',
              type: 'success'
            });
            this.getSampleList();
          },
          (res) => {
            this.loading--;
            this.$message.error(res);
          }
        );
      });
    },
    // 添加/编辑产品
    toGood(type, id) {
      this.$router.push({
        name: 'sample',
        query: {
          type,
          id
        }
      });
    },
    async order2excel() {
      // if(!(await this.exportLog())) return;
      this.loading++;
      let goodsList = [];
      let totalPage = null;
      let data = {
        page: this.currentPage,
        size: this.size,
        ...this.filter,
      };
      await this.httpGet(this.$root.getSampleList, data).then(
        (res) => {
          this.loading--;
          totalPage = Math.ceil(parseInt(res.total) / this.size);
        },
        () => {
          this.loading--;
        }
      );
      this.showProgressDialog = true;
      this.progress = 0;
      await this.getAllPages(totalPage, goodsList).then(
        () => {
          this.showProgressDialog = false;
          this.jsonFormatAndToExcel(goodsList);
        },
        (err) => {
          console.error(err);
          this.showProgressDialog = false;
        }
      );
    },
    async getAllPages(totalPage, list) {
      for (let i = 1; i <= totalPage; i++) {
        let data = {
          page: i,
          size: this.size,
          ...this.filter,
        };
        await this.httpGet(this.$root.getGoodsImportList, data).then((res) => {
          list.push(...res.list);
          this.progress = Math.floor((i / totalPage) * 100);
          console.log('page' + i, list.length);
        });
        // console.log(5555, list);
      }
    },
    getAttrs(attrs) {
      return attrs
        .map((item) => {
          return item.keyName + '：' + item.value;
        })
        .join('; ');
    },
    jsonFormatAndToExcel(list) {
      let formatList = [];
      list.forEach((item) => {
        item.skuList.forEach((sku, skuIndex) => {
          let obj = {};
          if(skuIndex === 0){
            obj = {
              ID: item.spu.id,
              产品名称: item.spu.name,
              // 产品主图: item.masterPic,
              关联分类: item.firstSortName,
              关联品牌: item.brandName,
              // '价格/元': item.minPrice,
              产品状态: item.spu.status === 3 ? "出售中" : "仓库中",
              规格编码: sku.code,
              规格名称: this.getAttrs(sku.attrs),
              普通会员价: +sku.price,
              库存: +sku.stock,
              划线价: +item.spu.linePrice,
              产品排序: item.spu.twig,
              创建时间: item.spu.created,
              更新时间: item.spu.updated,
              核算比例: item.spu.accountingRate
            }
          } else {
            obj = {
              // ID: '',
              // 产品名称: '',
              // 产品主图: '',
              // 关联分类: '',
              // 关联品牌: '',
              // '价格/元': item.minPrice,
              // 产品状态: '',
              规格编码: sku.code,
              规格名称: this.getAttrs(sku.attrs),
              普通会员价: sku.price,
              库存: sku.stock,
              // 划线价: null,
              // 产品排序: '',
              // 创建时间: '',
              // 更新时间: '',
              // 核算比例: ''
            }
          }
          // item.skuList.forEach((sku, index) => {
          //   obj[`规格${index + 1}`] = this.getAttrs(sku.attrs);
          //   obj[`规格${index + 1} 价格`] = sku.price;
          //   obj[`规格${index + 1} 库存`] = sku.stock;
          //   obj[`规格${index + 1} 编码`] = sku.code;
          // });
          formatList.push(obj);
        })
      });
      // console.log(formatList);
      myUtils.json2excel(formatList);
    }
  }
};
</script>
<style lang="stylus" rel="stylesheet/stylus">
@import '~assets/public.styl';
</style>
<style lang="stylus" rel="stylesheet/stylus" scoped>
@import '~assets/main.styl';

.goods-manage-box {
  height: 100%;
  width: 100%;
  flex-y(flex-start, flex-start);
  overflow-y: hidden;
  background: bg-color;

  .container {
    box-sizing: border-box;
    height: 100%;
    width: 100%;
    overflow-y: auto;
    flex-y(flex-start, flex-start);
    padding: 0 20px 20px;

    .blue {
      color: btn-color;
      cursor: pointer;
    }

    // content 表格
    .content {
      flex: 1;
      width: 100%;
      font-size: 14px;
      background: white;
      box-sizing: border-box;
      padding: 24px 32px;
      border-radius: 2px;

      .filter-box {
        flex-wrap: wrap;

        .btn-box {
          margin: 5px 0;
          flex-x(flex-start);
          flex-wrap: wrap;

          .label {
            margin-right: 6px;
            margin-left: 12px;
            word(14px, gray3);
          }

          .input {
            margin-right: 8px;
          }

          .search {
            min-width: 65px;
          }
        }
      }

      .import-box {
        width: 100%;
        flex-x(flex-end);
      }

      // 按钮
      .btn {
        width: 100px;
        height: 32px;
        line-height: 32px;
        confirm-btn();
        font-size: 14px;
        margin: 16px 0;
        flex-shrink: 0;
      }

      .table {
        .master-pic {
          width: auto;
          height: 32px;
        }
      }

      .vip-btn {
        width: 96px;
        height: 24px;
        border-radius: 4px;
        border: 1px solid #E8E8E8;
        background: #F7F7F7;
        word(12px, btn-color);
        flex-x(center);
        white-space: nowrap;
        margin: 0 5px;
        cursor: pointer;
      }

      .table-btn-box {
        flex-x(flex-end);

        .table-btn {
          width: 65px;
          min-width: 65px;
          height: 24px;
          line-height: 24px;
          color: gray3;
          font-size: 12px;
          margin-right: 8px;
          cancel-btn();
        }
      }
    }
  }

  .footer {
    width: 100%;
    padding: 24px;
    box-sizing: border-box;
    flex-x(flex-end);
    background: white;
  }

  .wx-category-box{
    flex-x();
    padding: 5px 0;
    background: #F7F7F7;
    .step{
      flex: 1;
      height: 320px;
      border-right: 1px solid #D8D8D8;
      background: #F7F7F7;
      padding: 0 10px;
      box-sizing: border-box;
      overflow-y: auto;
      .item{
        height: 36px;
        flex-x();
        padding: 0 12px;
        box-sizing: border-box;
        border-radius: 5px;
        &:hover{
          background: #F8E8E5;
        }
        &.active{
          background: #F8E8E5;
        }
      }
      &:nth-of-type(1){
        border-top-left-radius: 5px;
        border-bottom-left-radius: 5px;
      }
      &:nth-of-type(3){
        border-right: none;
      }
    }
  }
  .wx-category-box2{
    padding: 0 24px;
    box-sizing: border-box;
    .list{
      margin-top: 36px;
    }
    .item{
      margin: 6px 0;
      flex-x(flex-start);
      .label{
        width: 65px;
      }
      .input1{
        width: 160px;
      }
      .input2{
        width: 200px;
        margin-left: 12px;
      }
    }
  }
}
</style>
